module.exports = __webpack_public_path__ + "static/11-20f14967e4782613601b111e83a99a55.png";